module.exports = __webpack_public_path__ + "img/parents_choose_dark.b4d21bbc.png";